import React from 'react';

/**
 * Renders a translated template containing a single `{name}` placeholder,
 * substituting the patient name as a `privacy-text` span so the name stays
 * masked in privacy mode. Splitting on the placeholder (rather than string
 * interpolation) keeps the name a real React node and preserves each locale's
 * word order. If the template has no `{name}`, the name span is appended.
 */
export const renderWithPrivateName = (
  template: string,
  name: React.ReactNode,
): React.ReactNode => {
  const [before, after = ''] = template.split('{name}');
  return (
    <>
      {before}
      <span className="privacy-text">{name}</span>
      {after}
    </>
  );
};
